import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {
  footer = {
    telf: "",
    url: "",
    comunicate: ""
  }
  landing = {
    body: "",
  }
  otp = {
    body_1: "",
    body_2: "",
    body_3: "",
    body_error: "",
  }
  checkout = {
    register: "",
    payment: "",
    currency: "",
  }

  setFooter(locale: string) {
    const setLocaleCache = (telf: string, url: string, comunicate: string) => {
      localStorage.setItem("footer_telf", telf);
      localStorage.setItem("footer_url", url);
      localStorage.setItem("footer_comunicate", comunicate);
    };

    switch(locale) {
      case "AR":
        this.footer.telf = "0800 888 8188";
        this.footer.url = "prosegur.com.ar";
        this.footer.comunicate = "Si necesitás ayuda, comunicate con Atención al Cliente al ";
        break;
      case "CL":
        this.footer.telf = "600 580 8000";
        this.footer.url = "prosegur.cl";
        this.footer.comunicate = "Si necesitas ayuda, comunícate con nosotros al ";
        break;
      case "UY":
        this.footer.telf = "2915 2915";
        this.footer.url = "prosegur.com.uy";
        this.footer.comunicate = "Si necesitás ayuda, comunicate con Atención al Cliente al ";
        break;
      case "CO":
        this.footer.telf = "3183515058";
        this.footer.url = "prosegur.com.co";
        this.footer.comunicate = "Si necesitas ayuda, comunícate con nosotros al ";
        break;
      case "PE":
        this.footer.telf = "987 223 577"
        this.footer.url = "prosegur.com.pe";
        this.footer.comunicate = "Si necesitas ayuda, comunícate con nosotros al ";
        break;
    }
    setLocaleCache(this.footer.telf, this.footer.url, this.footer.comunicate);
  }

  setLanding(locale: string) {
    switch(locale) {
      case "AR":
      case "UY":
        this.landing.body = "Para comenzar con el proceso, tocá el botón y recibí tu código de activación vía SMS.";
        break;
      case "CL":
      case "CO":
      case "PE":
        this.landing.body = "Para comenzar con el proceso, toca el botón y recibe tu código de activación vía SMS.";
        break;
    }
  }

  setOtp(locale: string) {
    switch(locale) {
      case "AR":
      case "UY":
        this.otp.body_1 = "Se te ha enviado un SMS con tu código único de 6 dígitos. ";
        this.otp.body_2 = "Ingresalo acá.";
        this.otp.body_3 = "tocá acá para recibir uno nuevo.";
        this.otp.body_error = "Tocá acá para recibir un nuevo código por SMS.";
        break;
      case "CL":
      case "CO":
      case "PE":
        this.otp.body_1 = "Se te ha enviado un SMS con tu código único de 6 dígitos. ";
        this.otp.body_2 = "Ingrésalo aquí.";
        this.otp.body_3 = " toca aquí para recibir uno nuevo.";
        this.otp.body_error = "Toca aquí para recibir un nuevo código por SMS.";
        break;
    }
  }

  setCheckout(locale: string, amount: number, concept: string) {
    switch(locale) {
      case "AR":
      case "UY":
        this.checkout.register = "Ingresá los datos de tu tarjeta, tu información personal, tocá el botón de registrar";
        this.checkout.payment = `Para realizar el pago de ${this.checkout.currency}${amount.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} en concepto de "${concept}" ingresá los datos de la tarjeta, tu información personal, tocá el botón de pagar`;
        break;
      case "CL":
      case "CO":
      case "PE":
        this.checkout.register = "Ingresa los datos de tu tarjeta, tu información personal, toca el botón de registrar";
        this.checkout.payment = `Para realizar el pago de ${this.checkout.currency}${amount.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} en concepto de "${concept}" ingresa los datos de la tarjeta, tu información personal, toca el botón de pagar`;
        break;
    }
  }

  setCountryCurrency(locale: string) {
    switch(locale) {
      case "AR": 
        this.checkout.currency = "$"
        break;
      case "UY":
        this.checkout.currency = "$"
        break;
      case "CL":
        this.checkout.currency = "$"
        break;
      case "CO":
        this.checkout.currency = "$"
        break;
      case "PE":
        this.checkout.currency = "S/"
        break;
    }
  }
}
